export default __webpack_public_path__ + "static/media/tel.c497d0c8.svg";